export enum LangSwitcherType {
  dropDown = 'dropdown',
  inline = 'inline',
}
